module.exports = __webpack_public_path__ + "static/media/automation.498f1590.svg";